import iFrameResizer from '@iframe-resizer/parent';

iFrameResizer({
  license: '1jy4dww5qzv-s54r73oxcn-v59f4kfgfz',
  heightCalculationMethod: 'taggedElement',
  checkOrigin: true // Only uses domain from src tag in iframe
}, '#kalix-scheduler');